import type { FaireProductEntity } from "../../entity_types/product";

export const p_qhr3vt7avw: FaireProductEntity = {
  token: "p_qhr3vt7avw",
  type: "product",
  name: "acorn branch mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/ee0179341045dc7bcf51cb33b0604b529165d4016db222344e4c7aa230c0a86c.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation. \n\n\nDetails:\n\n- single card + envelope + sticker for sealing\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:10.782Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
